import SignUp from './SignUp';
import './SignUp.scss';

export default SignUp;
